const TRIAL_DAYS = 14;

export function getTrialDaysLeft(clientProfile) {
  if (!clientProfile || !clientProfile.created_at) return 0;

  const end = new Date(clientProfile.created_at);
  end.setDate(end.getDate() + TRIAL_DAYS);
  const now = new Date();

  return Math.max(0, Math.ceil((end - now) / 86400000));
}

export function getSubscriptionAccessState(clientProfile) {
  const status = clientProfile?.subscription_status;
  const permissions = clientProfile?.permissions || {};
  const hasUnlockedPermissions = Object.values(permissions).some(Boolean);
  const remainingTrialDays = getTrialDaysLeft(clientProfile);
  const trialWindowActive = remainingTrialDays > 0;

  const active = status === 'active';
  const trial = status === 'trial' && trialWindowActive;
  const pendingDuringTrial = status === 'pending' && trialWindowActive && hasUnlockedPermissions;
  const pendingLocked = status === 'pending' && !pendingDuringTrial;
  const canAccessPaidFeatures = active || trial || pendingDuringTrial;

  return {
    active,
    trial,
    pendingDuringTrial,
    pendingLocked,
    trialWindowActive,
    remainingTrialDays,
    hasUnlockedPermissions,
    canAccessPaidFeatures,
    effectiveStatus: active ? 'active' : (trial || pendingDuringTrial ? 'trial' : status),
  };
}
